import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringSlice'
})
export class StringSlicePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if(value != undefined && value != null && value != ''){
    if( value.charAt( 0 ) === '/' ){
      value = value.slice( 1 );
      value = value ? value : 'Index page';
    }
  }
    return value;
}

}
